'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { ReactNode, useState } from 'react';
import IconClose from '@/components/assets/icon_close.svg';
import { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle } from '@/components/ui/drawer';
import { useLayoutContext } from '@/context/LayoutContext';
type MobileCommentsDrawerProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: ReactNode;
};
const SNAP_POINTS = [0.7, 1] as const;
function MobileCommentsDrawer(t0) {
  const $ = _c(25);
  const {
    open,
    onOpenChange,
    children
  } = t0;
  const t = useTranslations();
  const {
    headerHeight
  } = useLayoutContext();
  const [snap, setSnap] = useState(SNAP_POINTS[0]);
  let t1;
  if ($[0] !== onOpenChange) {
    t1 = next => {
      if (next) {
        setSnap(SNAP_POINTS[0]);
      }
      onOpenChange(next);
    };
    $[0] = onOpenChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [...SNAP_POINTS];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `calc(100dvh - ${headerHeight}px)`;
  let t4;
  if ($[3] !== t3) {
    t4 = {
      maxHeight: t3
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="bg-vive-primary-40 mx-auto h-1 w-14 shrink-0 rounded-full" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t) {
    t6 = t("comments-panel.comments-count");
    $[6] = t;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <DrawerTitle className="text-[16px] leading-6 font-bold text-white">{t6}</DrawerTitle>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <DrawerDescription className="sr-only">Comments panel</DrawerDescription>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <DrawerClose aria-label="Close comments" className="bg-vive-primary-70/60 hover:bg-vive-primary-70/80 inline-flex size-6 shrink-0 items-center justify-center rounded-full"><IconClose className="size-3 text-white" /></DrawerClose>;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t7) {
    t10 = <DrawerHeader className="flex w-full flex-row items-center justify-between gap-2 border-b border-white/10 p-0 px-4 pb-[10.8px] text-left">{t7}{t8}{t9}</DrawerHeader>;
    $[12] = t7;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== children) {
    t11 = <div className="flex min-h-0 flex-1 flex-col overflow-hidden px-4 pb-4">{children}</div>;
    $[14] = children;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10 || $[17] !== t11 || $[18] !== t4) {
    t12 = <DrawerContent hideHandle={true} className="bg-background/70 mt-0 flex h-full flex-col gap-6 rounded-t-[25px] border-0 pt-2 backdrop-blur-[50px]" style={t4}>{t5}{t10}{t11}</DrawerContent>;
    $[16] = t10;
    $[17] = t11;
    $[18] = t4;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== open || $[21] !== snap || $[22] !== t1 || $[23] !== t12) {
    t13 = <Drawer open={open} onOpenChange={t1} shouldScaleBackground={false} snapPoints={t2} activeSnapPoint={snap} setActiveSnapPoint={setSnap}>{t12}</Drawer>;
    $[20] = open;
    $[21] = snap;
    $[22] = t1;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
}
export default MobileCommentsDrawer;